import { WITHDRAWAL_DEPOSIT_COMMENT_ENTITY_PREFIX } from "helpers/withdrawalDepositConstants";
import { isInternalRecordId } from "helpers/withdrawalDepositIdentifiers";

export { WITHDRAWAL_DEPOSIT_COMMENT_ENTITY_PREFIX } from "helpers/withdrawalDepositConstants";

/** Canonical entity_id for WD comment APIs — the withdrawal/deposit form UUID. */
export function withdrawalDepositCommentEntityId(formId: string): string {
  return String(formId).trim();
}

export function parseWithdrawalDepositCommentEntityId(
  entityId: string | undefined | null,
): string | null {
  if (!entityId) return null;
  const raw = String(entityId).trim();
  if (raw.startsWith(WITHDRAWAL_DEPOSIT_COMMENT_ENTITY_PREFIX)) {
    const parsed = raw
      .slice(WITHDRAWAL_DEPOSIT_COMMENT_ENTITY_PREFIX.length)
      .trim();
    return parsed || null;
  }
  if (isInternalRecordId(raw)) {
    return raw;
  }
  return null;
}
